import React, { useEffect, useState } from 'react'
import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const applyPagination = (medicosLista, page, limit) => {
    return medicosLista.slice(page * limit, page * limit + limit);
};

export default function ListaAgenda() {
    const { t } = useTranslation();
    const [page, setPage] = useState(0);
    const [lista, setLista] = useState([])
    const [limit, setLimit] = useState(10);
    const handlePageChange = (_event, newPage) => {
        setPage(newPage);
    };
    useEffect(() => {
        const getDatos = async () => {
            let response = await axios.get('http://132.157.160.67:4001/getPetitorio')
            if (response.status === 200) {
                setLista(response.data)
            }
        }
        getDatos()
    }, [])
    const handleLimitChange = (event) => {
        setLimit(parseInt(event.target.value));
    };

    useEffect(() => {
        console.log(lista)
    }, [lista])

    const [valorBuscado, setValorBuscado] = useState('');
    const [objetosEncontrados, setObjetosEncontrados] = useState([]);

    const buscarPorValor = (valor) => {
        // const objetosEncontrados = lista.filter((objeto) => objeto.denominacion === valor);
        const objetosEncontrados = lista.filter(
            (objeto) => objeto.denominacion.toUpperCase().includes(valor.toUpperCase())
          );
        setObjetosEncontrados(objetosEncontrados);
    };

    const handleInputChange = (event) => {
        const valorIngresado = event.target.value;
        setValorBuscado(valorIngresado);
        buscarPorValor(valorIngresado);
    };

    const paginatedmedicosLista = applyPagination(lista, page, limit);

    return (
        <>
            <Grid container>
                <Grid lg={6}>
                    <TextField
                        value={valorBuscado}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                        style={{ margin: "15px", padding: "0px" }}
                        label="Buscar item"
                    />
                </Grid>
            </Grid>
            {
                objetosEncontrados.length > 0 ?
                    <>

                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('Codigo')}</TableCell>
                                        <TableCell>{t('Denominación')}</TableCell>
                                        <TableCell>{t('Concentración')}</TableCell>
                                        <TableCell>{t('Forma Farmaceutica SIMP')}</TableCell>
                                        <TableCell>{t('Detalle')}</TableCell>
                                        <TableCell>{t('Presentación')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {objetosEncontrados.map((list, ix) => {
                                        return (
                                            <TableRow hover key={ix} >
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.id}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.denominacion}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.concentracion}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.formaFarmaceuticaSIMP}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.detalle}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.presentacion}
                                                    </Typography>
                                                </TableCell>

                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                       
                    </>
                    :
                    <>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('Codigo')}</TableCell>
                                        <TableCell>{t('Denominación')}</TableCell>
                                        <TableCell>{t('Concentración')}</TableCell>
                                        <TableCell>{t('Forma Farmaceutica SIMP')}</TableCell>
                                        <TableCell>{t('Detalle')}</TableCell>
                                        <TableCell>{t('Presentación')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedmedicosLista.map((list, ix) => {
                                        return (
                                            <TableRow hover key={ix} >
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.id}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.denominacion}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.concentracion}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.formaFarmaceuticaSIMP}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.detalle}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography noWrap variant="h5">
                                                        {list.presentacion}
                                                    </Typography>
                                                </TableCell>

                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box p={2}>
                            <TablePagination
                                component="div"
                                count={lista.length}
                                onPageChange={handlePageChange}
                                onRowsPerPageChange={handleLimitChange}
                                page={page}
                                rowsPerPage={limit}
                                rowsPerPageOptions={[5, 10, 15]}
                            />
                        </Box>
                    </>
            }
        </>
    )
}
